<template>
  <div>
    <div v-if="appType === 'parent'" style="margin-top: 5px">
      <div>
        <el-row type="flex" :gutter="6">
          <el-col :span="3">
            <!-- chọn khối -->
            <el-select
                style="width: 100%"
                clearable
                v-model="dataSearchStudent.idGrade"
                placeholder="Chọn khối"
                @change="handleSearchStudentsByGrade"
            >
              <el-option
                  v-for="item in gradeOfSchoolList"
                  :key="item.id"
                  :value="item.id"
                  :label="item.gradeName"
              ></el-option>
            </el-select>
          </el-col>

          <el-col :span="3">
            <!-- chọn lớp -->
            <el-select
                style="width: 100%"
                filterable
                clearable
                v-model="dataSearchStudent.idClass"
                placeholder="Chọn lớp"
                @change="handleSearchStudents"
                :disabled="!dataSearchStudent.idGrade"
            >
              <el-option
                  v-for="item in classList"
                  :key="item.id"
                  :value="item.id"
                  :label="item.className"
              ></el-option>
            </el-select>
          </el-col>
        </el-row>
      </div>
    </div>
    <div v-else>
      <div>
        <el-row type="flex" :gutter="6">
          <el-col :span="4">
            <!-- chọn phòng ban -->
            <el-select
                style="width: 100%"
                clearable
                v-model="idDepartment"
                placeholder="Chọn phòng ban"
                @change="handleFilterEmployee"
            >
              <el-option
                  v-for="item in departmentList"
                  :key="item.id"
                  :value="item.id"
                  :label="item.departmentName"
              ></el-option>
            </el-select>
          </el-col>
        </el-row>
      </div>
    </div>

    <div>
      <el-tabs type="card" v-model="activeName" @tab-click="handleClickTab">
        <!-- tab icon Parent -->
        <el-tab-pane label="App Onekids" name="appOnekids">
          <el-row type="flex" :gutter="20">
            <el-col :span="8">
              <el-table
                  border
                  :data="studentList"
                  highlight-current-row
                  :header-cell-style="tableHeaderColor"
                  :max-height="$tableMaxHeight"
                  v-loading="isLoading.students"
                  :element-loading-text="$tableLoading"
                  element-loading-spinner="el-icon-loading"
                  @selection-change="handleSelectionStudentsChange"
                  ref="tableDataKids"
              >
                <el-table-column
                    type="selection"
                    width="55"
                    align="center"
                    fixed="left"
                />

                <el-table-column
                    type="index"
                    label="STT"
                    align="center"
                    width="50"
                    fixed="left"
                />

                <el-table-column
                    label="Họ và tên"
                    fixed="left"
                >
                  <template v-slot:default="scope">
                    <span>{{ scope.row.fullName }}</span>
                  </template>
                </el-table-column>

                <template #empty>
                  <div style="color: #409EFF; font-size: 16px">
                    <span>
                      <i class="el-icon-warning"/>
                      Không có dữ liệu
                    </span>
                  </div>
                </template>
              </el-table>
            </el-col>

            <el-col :span="16">
              <div>
                <el-row type="flex" :gutter="10">
                  <el-col :span="12">
                    <div>
                      <!-- table 1 -->
                      <el-table
                          class="table-icon-1"
                          border
                          :data="parentIconAppUpdate.parentIconUpdate1"
                          highlight-current-row
                          :header-cell-style="tableHeaderColor"
                          @selection-change="handleSelectionChangeParent1"
                      >
                        <el-table-column
                            type="selection"
                            width="55"
                            align="center"
                        ></el-table-column>
                        <el-table-column type="index" label="STT" align="center" width="50"></el-table-column>
                        <el-table-column
                            prop="iconName"
                            label="Chức năng"
                        ></el-table-column>
                        <el-table-column label="Hiển thị" align="center" width="80">
                          <template v-slot:default="scope">
                            <el-checkbox v-model="scope.row.statusShow"></el-checkbox>
                          </template>
                        </el-table-column>
                        <el-table-column label="Mở khóa" align="center" width="80">
                          <template v-slot:default="scope">
                            <el-checkbox
                                v-if="scope.row.rootLockStatus"
                                v-model="scope.row.status"
                            ></el-checkbox>
                            <el-checkbox v-else disabled></el-checkbox>
                          </template>
                        </el-table-column>
                      </el-table>
                    </div>
                  </el-col>

                  <el-col :span="12">
                    <div>
                      <!-- table 2 -->
                      <el-table
                          class="table-icon-2"
                          border
                          :data="parentIconAppUpdate.parentIconUpdate2"
                          highlight-current-row
                          :header-cell-style="tableHeaderColor"
                          @selection-change="handleSelectionChangeParent2"
                      >
                        <el-table-column
                            type="selection"
                            width="55"
                            align="center"
                        ></el-table-column>
                        <el-table-column type="index" label="STT" align="center" width="50"></el-table-column>
                        <el-table-column
                            prop="iconName"
                            label="Chức năng"
                        ></el-table-column>

                        <el-table-column label="Hiển thị" align="center" width="80">
                          <template v-slot:default="scope">
                            <el-checkbox v-model="scope.row.statusShow"></el-checkbox>
                          </template>
                        </el-table-column>

                        <el-table-column label="Mở khóa" align="center" width="80">
                          <template v-slot:default="scope">
                            <el-checkbox

                                v-if="scope.row.rootLockStatus"
                                v-model="scope.row.status"
                            ></el-checkbox>
                            <el-checkbox v-else disabled></el-checkbox>
                          </template>
                        </el-table-column>
                      </el-table>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </el-col>
          </el-row>
        </el-tab-pane>

        <!-- tab icon Teacher -->
        <el-tab-pane label="App Teacher" name="appTeacher">
          <el-row type="flex" :gutter="20">
            <el-col :span="8">
              <el-table
                  border
                  :data="teacherList"
                  highlight-current-row
                  :header-cell-style="tableHeaderColor"
                  @selection-change="handleSelectionTeachersChange"
                  :max-height="$tableMaxHeight"
                  v-loading="isLoading.teachers"
                  :element-loading-text="$tableLoading"
                  element-loading-spinner="el-icon-loading"
                  ref="tableDataTeachers"
              >
                <el-table-column
                    type="selection"
                    width="55"
                    align="center"
                    fixed="left"
                />

                <el-table-column
                    type="index"
                    label="STT"
                    align="center"
                    width="50"
                    fixed="left"
                />

                <el-table-column
                    label="Họ và tên"
                    fixed="left"
                >
                  <template v-slot:default="scope">
                    <span>{{ scope.row.fullName }}</span>
                  </template>
                </el-table-column>

                <template #empty>
                  <div style="color: #409EFF; font-size: 16px">
                    <span>
                      <i class="el-icon-warning"/>
                      Không có dữ liệu
                    </span>
                  </div>
                </template>
              </el-table>
            </el-col>

            <el-col :span="16">
              <div>
                <el-row type="flex" :gutter="10">
                  <el-col :span="12">
                    <div>
                      <!-- table 1 -->
                      <el-table
                          class="table-icon-1"
                          border
                          :data="teacherIconAppUpdate.teacherIconUpdate1"
                          highlight-current-row
                          :header-cell-style="tableHeaderColor"
                          @selection-change="handleSelectionChangeTeacher1"

                      >
                        <el-table-column
                            type="selection"
                            width="55"
                            align="center"
                        ></el-table-column>
                        <el-table-column type="index" label="STT" align="center"></el-table-column>
                        <el-table-column prop="iconName" label="Chức năng"></el-table-column>

                        <el-table-column label="Hiển thị" align="center" width="80">
                          <template v-slot:default="scope">
                            <el-checkbox v-model="scope.row.statusShow"></el-checkbox>
                          </template>
                        </el-table-column>

                        <el-table-column label="Mở khóa" align="center" width="80">
                          <template v-slot:default="scope">
                            <el-checkbox
                                v-if="scope.row.rootLockStatus"
                                v-model="scope.row.status"
                            ></el-checkbox>
                            <el-checkbox v-else disabled></el-checkbox>
                          </template>
                        </el-table-column>
                      </el-table>
                    </div>
                  </el-col>

                  <el-col :span="12">
                    <div>
                      <!-- table 2 -->
                      <el-table
                          class="table-icon-2"
                          border
                          :data="teacherIconAppUpdate.teacherIconUpdate2"
                          highlight-current-row
                          :header-cell-style="tableHeaderColor"
                          @selection-change="handleSelectionChangeTeacher2"

                      >
                        <el-table-column
                            type="selection"
                            width="55"
                            align="center"
                        ></el-table-column>
                        <el-table-column type="index" label="STT" align="center"></el-table-column>
                        <el-table-column prop="iconName" label="Chức năng"></el-table-column>

                        <el-table-column label="Hiển thị" align="center" width="80">
                          <template v-slot:default="scope">
                            <el-checkbox v-model="scope.row.statusShow"></el-checkbox>
                          </template>
                        </el-table-column>

                        <el-table-column label="Mở khóa" align="center" width="80">
                          <template v-slot:default="scope">
                            <el-checkbox
                                v-if="scope.row.rootLockStatus"
                                v-model="scope.row.status"
                            ></el-checkbox>
                            <el-checkbox v-else disabled></el-checkbox>
                          </template>
                        </el-table-column>
                      </el-table>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </el-col>
          </el-row>
        </el-tab-pane>
      </el-tabs>
    </div>


    <!-- buton click -->
    <div class="tab-infor-button">
      <el-button
          type="success"
          size="medium"
          :loading="loadingButton"
          @click="submitForm()"
          icon="el-icon-circle-check"
      >
        <span>Lưu</span>
      </el-button>
    </div>

  </div>
</template>

<script>
import StudentService from "@/services/StudentService";
import EmployeeDataService from "@/services/EmployeeService/EmployeeDataService";
import {mapState} from "vuex";

export default {
  components: {},
  props: {
    dialogVisible: null,
  },
  created() {
    this.$store.dispatch('departmentStore/fetchDataDepartmentList');
    this.$store.dispatch('gradeModule/fetchDataGradeOfSchoolList');
    this.$store.dispatch('classStore/fetchDataClassListCommon');
    this.getDataInitial()
    this.fetchDataStudents();
    this.fetchDataEmployees();
  },
  computed: {
    ...mapState('gradeModule', ['gradeOfSchoolList']),
    ...mapState('classStore', ['classListCommon']),
    ...mapState('departmentStore', ['departmentList']),
    classList() {
      return this.classListCommon.filter((x) => x.idGrade === this.dataSearchStudent.idGrade);
    },
  },
  data() {
    return {
      activeName: "appOnekids",
      appType: "parent",
      classOfGradeList: [],
      parentIconAppUpdate: {
        parentIconUpdate1: [],
        parentIconUpdate2: [],
      },
      formAllTabStudent: {
        parentIconApp: [],
      },
      formAllTabTeacher: {
        teacherIconApp: [],
      },
      value: "",
      loadingButton: false,
      teacherIconAppUpdate: {
        teacherIconUpdate1: [],
        teacherIconUpdate2: [],
      },

      dataSearchStudent: {
        idGrade: null,
        idClass: null,
      },
      idDepartment: null,
      multipleSelectionParent1: [],
      multipleSelectionParent2: [],
      multipleSelectionTeacher1: [],
      multipleSelectionTeacher2: [],

      multipleSelectionData: {
        kids: [],
        teachers: []
      },

      studentList: [],
      teacherList: [],
      isLoading: {
        students: false,
        teachers: false,
      }
    };
  },
  watch: {

  },
  methods: {
    tableHeaderColor() {
      return "background-color: #78a5e7;color: #fff;font-weight: bold;";
    },
    //reset when click x
    closeDialog() {
      this.$emit("dialog-close");
      setTimeout(() => {
        this.clearTabDefault();
      }, 300);
    },
    closeDialogByButton(fromData) {
      this.$refs[fromData].resetFields();
      this.$emit("dialog-close");


      setTimeout(() => {
        this.clearTabDefault();
      }, 300);
    },
    handleClickTab(tab) {
      if (tab.name === "appOnekids") {
        this.appType = "parent"
        this.tabParentIconMethod();
      } else {
        this.appType = "teacher"
        this.tabTeacherIconMethod();
      }
    },
    clearTabDefault() {
      this.activeName = "appOnekids";
    },
    submitForm() {
      if (this.appType === 'parent') {
        let iconArray = this.multipleSelectionParent1.concat(this.multipleSelectionParent2)
        if (iconArray.length === 0) {
          this.$message({
            message: "Không có Icon App Parent nào được chọn",
            type: "error",
          });
        } else if (this.multipleSelectionData.kids.length === 0) {
          this.$message({
            message: "Không có học sinh nào được chọn",
            type: "error",
          });
        } else {
          this.saveDataIconAppParent(iconArray);
        }
      } else {
        let iconArrayTeacher = this.multipleSelectionTeacher1.concat(this.multipleSelectionTeacher2)
        if (iconArrayTeacher.length === 0) {
          this.$message({
            message: "Không có Icon App Teacher nào được chọn",
            type: "error",
          });
          this.loadingButton = false;
        } else if (this.multipleSelectionData.teachers.length === 0) {
          this.$message({
            message: "Không có nhân sự nào được chọn",
            type: "error",
          });
        } else {
          this.saveDataIconAppTeacher(iconArrayTeacher);
        }
      }
    },

    saveDataIconAppParent(iconArray) {
      const dataUpdateParent = {
        listId: this.multipleSelectionData.kids.map(kid => kid.id),
        parentIconAppList: iconArray,
      }

      this.loadingButton = true;
      StudentService.updateAppIconParentForManyStudent(dataUpdateParent)
          .then((resp) => {
            this.$message({
              message: resp.data.message,
              type: resp.data.data === true ? "success" : "error",
            });
            setTimeout(() => {
              this.tabParentIconMethod()
              this.loadingButton = false;
            }, 500);
            this.resetSelectionTableKids();
          })
          .catch((err) => {
            this.$message({
              message: err.data.message,
              type: "error",
            });
          })
          .finally(() => {
            this.loadingButton = false;
          });
    },

    saveDataIconAppTeacher(iconArrayTeacher) {
      const dataUpdateTeacher = {
        listId: this.multipleSelectionData.teachers.map(teacher => teacher.id),
        appIconTeacherRequestList: iconArrayTeacher
      }

      this.loadingButton = true;
      EmployeeDataService.updateAppIconForManyTeacher(dataUpdateTeacher)
          .then((resp) => {
            this.$message({
              message: resp.data.message,
              type: resp.data.data === true ? "success" : "error",
            });
            setTimeout(() => {
              this.tabTeacherIconMethod()
              this.loadingButton = false;
            }, 500);
            this.resetSelectionTableTeachers();
          })
          .catch((err) => {
            this.$message({
              message: err.data.message,
              type: "error",
            });
          })
          .finally(() => {
            this.loadingButton = false;
          });
    },

    tabParentIconMethod() {
      StudentService.findAllAppIconParentForSchool()
          .then((resp) => {
            this.parentIconAppUpdate.parentIconUpdate1 =
                resp.data.data.appIconResponseList1
            this.parentIconAppUpdate.parentIconUpdate2 =
                resp.data.data.appIconResponseList2
          })
          .catch((err) => {
            console.log(err);
          });
    },
    tabTeacherIconMethod() {
      EmployeeDataService.findAllAppIconTeacherForSchool()
          .then((resp) => {
            this.teacherIconAppUpdate.teacherIconUpdate1 =
                resp.data.data.appIconTeacherResponseList1
            this.teacherIconAppUpdate.teacherIconUpdate2 =
                resp.data.data.appIconTeacherResponseList2
          })
          .catch((err) => {
            console.log(err);
          });
    },
    getDataInitial() {
      this.tabParentIconMethod();
      this.tabTeacherIconMethod()
    },

    /**
     * thay đổi khối
     */
    changeGradeMethod() {
      this.dataSearchStudent.idClass = null;
    },
    handleSelectionChangeParent1(val) {
      this.multipleSelectionParent1 = val;
    },
    handleSelectionChangeParent2(val) {
      this.multipleSelectionParent2 = val;
    },
    handleSelectionChangeTeacher1(val) {
      this.multipleSelectionTeacher1 = val;
    },
    handleSelectionChangeTeacher2(val) {
      this.multipleSelectionTeacher2 = val;
    },

    handleSearchStudents() {
      this.fetchDataStudents();
    },

    handleSearchStudentsByGrade() {
      this.dataSearchStudent.idClass = "";
      this.fetchDataStudents();
    },

    fetchDataStudents() {
      const idGrade = this.dataSearchStudent.idGrade;
      const idClass = this.dataSearchStudent.idClass;
      const param = {
        idGrade: idGrade,
        idClass: idGrade ? idClass : ""
      }
      this.isLoading.students = true;
      StudentService.getKidsByGradeAndClass(param)
          .then((res) => {
            this.studentList = res.data.data;
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            this.isLoading.students = false;
          })
    },

    handleSelectionStudentsChange(value) {
      this.multipleSelectionData.kids = value;
    },

    resetSelectionTableKids() {
      this.multipleSelectionData.kids = [];
      this.$refs.tableDataKids.clearSelection();
    },

    resetSelectionTableTeachers() {
      this.multipleSelectionData.teachers = [];
      this.$refs.tableDataTeachers.clearSelection();
    },

    handleFilterEmployee() {
      this.fetchDataEmployees();
    },

    fetchDataEmployees() {
      const idDepartment = this.idDepartment;

      const params = {
        idDepartment: idDepartment,
      }

      this.isLoading.teachers = true;
      EmployeeDataService.getEmployeesByDepartment(params)
          .then(res => {
            this.teacherList = res.data.data;
          })
          .catch(err => {
            console.log(err);
          })
          .finally(() => {
            this.isLoading.teachers = false;
          })
    },

    handleSelectionTeachersChange(value) {
      this.multipleSelectionData.teachers = value;
    }
  },
};
</script>
<style>
.hideUpload > div {
  display: none;
}
</style>
<style lang="scss" scoped>
/deep/ .el-dialog__title {
  font-size: 25px;
  color: #606266;
}

/deep/ .el-dialog__body {
  padding-top: 0;
}

/deep/ .el-form-item__label {
  font-family: Arial, Helvetica, sans-serif;
}

/deep/ .el-button--primary {
  width: 100%;
  background: #409eff;
}

/deep/ .el-input.is-disabled .el-input__inner {
  color: #606266;
}

/deep/ .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:after {
  content: "*";
  color: #f56c6c;
  margin-left: 3px;
}

/deep/ .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:before {
  content: "";
  color: #f56c6c;
  margin-left: -4px;
}

/deep/ input::-webkit-outer-spin-button,
/deep/ input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/deep/ .el-input.is-disabled .el-input__inner {
  color: #606266;
  background: #e7e9ec;
  border: 1px solid #dcdfe6;
}

/deep/ .el-tabs__item {
  color: white;
}

/deep/ .el-tabs__item.is-active {
  color: white;
  background: #78a5e7;
}

/deep/ .el-form-item__label {
  font-family: Arial, Helvetica, sans-serif;
}

/deep/ .el-tabs__nav-scroll {
  float: right;
  margin-right: 50px;
}

/deep/ .el-table td,
/deep/ .el-table th {
  padding: 10px 0;
}

/deep/ .el-tabs__nav {
  background: #a0a19ce0;
}

.el-select {
  display: block;
}

.tab-infor-button {
  text-align: right;
  margin-top: 20px;
}

.bg-purple {
  background: #d3dce6;
}

.grid-content {
  border-radius: 4px;
  min-height: 36px;
}

.group-radio-status {
  margin: 0 50px;

  .kids-status {
    margin-bottom: 10px;
  }
}

.table-data {
  width: 60%;
  border-collapse: collapse;
  border: 1px solid #ebeef5;
  margin: 0 auto;
}

.wrapper-table {
  overflow-y: scroll;
  border-bottom: 1px solid #ebeef5;
}

.button-left-class {
  margin-right: 5px;
  width: 200px;
}

.button-click-left {
  margin-top: 5px;
  display: flex;
  align-items: center;
  margin-bottom: -20px;
  position: relative;
  z-index: 1
}

.button-click-left .el-select {
  margin-right: 10px;
}

</style>
